export const EVENT_NAME = {
  UNDO: "Selection Removal Undone"
};

export const MODULE = "bet_ticket";
